export function getLockIconStyle(aspectNames): {
  title: string;
  class: string;
} {
  const iconStyle = {
    title: '',
    class: 'no-icon',
  };

  if (aspectNames && aspectNames.indexOf('cm:workingcopy') !== -1) {
    iconStyle.title = 'Checked-out';
    iconStyle.class = 'wk-icon-lock-keyed';
  }

  return iconStyle;
}
